export enum LOCAL_STORAGE_KEYS {
    MAGIC_LINK_EMAIL = 'slicesize_magic_link_email',
    CART_KEY = 'slicesize_cart',
    LAST_ORDER_KEY = 'slicesize_last_order',
    WORKSTATION_NAME = 'slicesize_workstation_name',
    CARD_TERMINAL_NAME = 'slicesize_card_terminal_name',
}
